import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { walletPaths } from "api/apiPaths";
import client from "api/client";
import { WalletsRequestModel } from "./model/WalletsRequestModel";
import { WalletsResponseModel } from "./model/WalletsResponseModel";
import { CreateWalletsRequestModel } from "./model/create/CreateWalletsRequestModel";
import { WalletsDetailResponseModel } from "./model/details/WalletsDetailResponseModel";
import { UpdateWalletsRequestModel } from "./model/update/UpdateWalletsResponseModel";

export interface IWalletsRepository {
  getList(
    params: WalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<WalletsDetailResponseModel>>;
  createWallet(
    body: CreateWalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsDetailResponseModel>>;
  updateWallet(
    body: UpdateWalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsDetailResponseModel>>;
  deleteWallet(params: {
    code: string;
  }): Promise<BaseApiResponseModel<WalletsDetailResponseModel>>;
}

class WalletsImpl implements IWalletsRepository {
  async getList(
    params: WalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsResponseModel[]>> {
    return await client?.get(walletPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<WalletsDetailResponseModel>> {
    return await client?.get(walletPaths?.DETAIL, params);
  }

  async updateWallet(
    body: UpdateWalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsDetailResponseModel>> {
    return await client?.put(walletPaths?.UPDATE, body);
  }

  async createWallet(
    body: CreateWalletsRequestModel
  ): Promise<BaseApiResponseModel<WalletsDetailResponseModel>> {
    return await client?.post(walletPaths?.CREATE, body);
  }

  async deleteWallet(params: {
    code: string;
  }): Promise<BaseApiResponseModel<WalletsDetailResponseModel>> {
    return await client?.delete(walletPaths?.DELETE, params);
  }
}

export const defaultWalletsRepository = new WalletsImpl();
